import _ from 'lodash';
import React, { useEffect, useState, useMemo } from 'react';
import {
  Col, Row,
  Button,
  Form, FormGroup,
  Input, Label,
  Card, CardBody, CardHeader,
  ModalBody,
  ModalFooter,
  ModalHeader,
  CustomInput
} from 'reactstrap';
import ReactSelect from 'react-select';
import DatePicker from 'react-datepicker';
import ImageField from 'components/ImageField/index'
import { LangOptions } from './assets'
import MultilingualRTE from 'components/MultiLangRTE'
import MultilingualInput from 'components/MultiLangInput/v2'
import Lang from 'Lang/General';
import LinkInput from '../../FairsExhibitors/Forms/Utility/linkInput'

function IndustryForm({
  data,
  mode,
  stages,
  pages,
  users,
  fairs,
  onSubmit,
  onClose,
  anchorLinks,
  toggleMediaDatabase,
  selectedProgramme
}) {
  const [formData, setFormData] = useState({
    start_date_time: null,
    end_date_time: null,
    event_id: '',
    show_buy_ticket: false,
    show_extra_button: false,
    extra_button_json: {
      content: {
        de: '',
        en: '',
        nl: '',
        it: ''
      }
    },
    description: {
      de: '',
      en: ''
    },
    short_description: {
      de: '',
      en: ''
    },
    stage_id: null,
    fair_id: null,
    user_id: null,
    languages: [
      {
        label: 'GERMAN',
        value: 'GERMAN'
      }
    ],
    first_name: '',
    last_name: '',
    portrait: {
      url: '',
      raw: '',
      filename: ''
    },
  })

  useEffect(() => {
    if (mode === 'edit' && selectedProgramme) {
      let temp = {
        ...selectedProgramme,
        start_date_time: selectedProgramme.start_date_time || null,
        end_date_time: selectedProgramme.end_date_time || null,
        languages: _.map(selectedProgramme.languages, langChild => ({
          value: langChild,
          label: langChild
        })),
        extra_button_json: _.isEmpty(selectedProgramme?.extra_button_json) ? {
          content: {
            en: '',
            de: '',
            nl: '',
            it: ''
          }
        } : {
          ...selectedProgramme.extra_button_json,
          content: typeof selectedProgramme.extra_button_json.content !== 'object' ? {
            en: '',
            de: '',
            nl: '',
            it: '',
          } : selectedProgramme.extra_button_json.content
        }
      }
      setFormData(temp)
    }
  }, [selectedProgramme])


  const onChangeField = (key, val) => setFormData({
    ...formData,
    [key]: val
  })

  const tempFair = useMemo(() => {
    let temp = _.find(fairs, child => {
      return +formData.fair_id === child.id
    })

    return temp
  }, [fairs, formData.fair_id])

  return (
    <>
      <ModalHeader toggle={() => onClose()} >
        {Lang[mode === 'create' ? 'CREATE_PROGRAMME' : 'UPDATE_PROGRAMME'][data.languageReducer.userSettings.admin_panel_language]}</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col lg={4}>
              <FormGroup>
                <Label>
                  {Lang['USERS'][data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  type={"select"}
                  value={formData.user_id}
                  disabled={mode === 'edit'}
                  onChange={e => setFormData({
                    ...formData,
                    user_id: e.target.value,
                    fair_id: null,
                    stage_id: null,
                    start_date_time: null,
                    end_date_time: null,
                  })}
                >
                  <option></option>
                  {users.map((data) => (
                    <option key={data.id} value={data.id}>
                      {data.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col lg={4}>
              <FormGroup>
                <Label>
                  {Lang['FAIRS'][data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  type={"select"}
                  value={formData.fair_id}
                  disabled={formData.user_id === null}
                  onChange={e => setFormData({
                    ...formData,
                    fair_id: e.target.value,
                    stage_id: null,
                    start_date_time: null,
                    end_date_time: null,
                  })}
                >
                  <option></option>
                  {
                    _.filter(fairs, fairChild => {
                      if (formData.user_id !== null) {
                        let tempUser = _.find(users, userChild => userChild.id === +formData.user_id)

                        if (tempUser) {
                          return _.findIndex(tempUser.fairs, userFairChild => userFairChild.id === fairChild.id) > -1
                        } else {
                          return false
                        }
                      } else {
                        return false
                      }
                    }).map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.name}
                      </option>
                    ))
                  }
                </Input>
              </FormGroup>
            </Col>
            <Col lg={4}>
              <FormGroup>
                <Label>
                  {Lang['STAGES'][data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  type={"select"}
                  value={+formData.stage_id}
                  onChange={e => onChangeField('stage_id', e.target.value)}
                >
                  <option></option>
                  {_.filter(stages, stageChild => stageChild.fair_id === +formData.fair_id).map((data) => (
                    <option key={data.id} value={data.id}>
                      {data.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col lg={6}>
              <Label>
                {Lang['START_DATETIME'][data.languageReducer.userSettings.admin_panel_language]}
              </Label>
              <DatePicker
                locale={data.languageReducer.userSettings.admin_panel_language}
                className="form-control"
                minDate={tempFair ? new Date(tempFair.start_date) : null}
                maxDate={tempFair ? new Date(tempFair.end_date) : null}
                popperPlacement='bottom-start'
                popperModifiers={{
                  flip: { behavior: ['bottom'] },
                  preventOverflow: { enabled: false },
                  hide: { enabled: false }
                }}
                showTimeSelect={true}
                timeFormat={'HH:mm'}
                dateFormat={`dd/MM/yyyy HH:mm`}
                selected={formData.start_date_time ? new Date(formData.start_date_time) : null}
                onChange={date => {
                  const newDate = new Date(date.getTime());

                  // Set the date to one hour later
                  newDate.setHours(newDate.getHours() + 1);
                  setFormData({
                    ...formData,
                    start_date_time: date,
                    end_date_time: newDate
                  })
                }} />
            </Col>
            <Col lg={6}>
              <Label>
                {Lang['END_DATETIME'][data.languageReducer.userSettings.admin_panel_language]}
              </Label>
              <DatePicker
                locale={data.languageReducer.userSettings.admin_panel_language}
                className="form-control"
                popperPlacement='bottom-start'
                disabled={!formData.start_date_time}
                minDate={tempFair ? new Date(formData.start_date_time) : null}
                maxDate={tempFair ? new Date(formData.start_date_time) : null}
                popperModifiers={{
                  flip: { behavior: ['bottom'] },
                  preventOverflow: { enabled: false },
                  hide: { enabled: false }
                }}
                showTimeSelect={true}
                timeFormat={'HH:mm'}
                dateFormat={`dd/MM/yyyy HH:mm`}
                selected={formData.end_date_time ? new Date(formData.end_date_time) : null}
                onChange={date => onChangeField('end_date_time', date)}
              />
            </Col>
            <Col lg={12}>
              <Label>
                {Lang['LANGUAGES'][data.languageReducer.userSettings.admin_panel_language]}
              </Label>
              <ReactSelect
                isMulti
                options={_.map(LangOptions, lang => ({
                  label: Lang[lang][data.languageReducer.userSettings.admin_panel_language],
                  value: lang
                }))}
                onChange={val => {
                  onChangeField('languages', val)
                }}
                value={formData.languages}
                styles={{
                  menu: provided => ({ ...provided, zIndex: 999 }),
                  menuPortal: provided => ({ ...provided, zIndex: 999 })
                }}
                placeholder={Lang['SELECT_LANGUAGES'][data.languageReducer.userSettings.admin_panel_language]} />
            </Col>
            <Col lg={12}>
              <FormGroup style={{ marginTop: 10 }}>
                <CustomInput
                  id="show_buy_ticket"
                  type="checkbox"
                  label={Lang['SHOW_BUY_TICKET'][data.languageReducer.userSettings.admin_panel_language] + ' ?'}
                  checked={formData.show_buy_ticket}
                  onChange={e => {
                    setFormData({
                      ...formData,
                      show_buy_ticket: e.target.checked,
                      event_id: ''
                    })
                  }} />
              </FormGroup>
            </Col>

            <Col lg={12}>
              <FormGroup>
                <CustomInput
                  id="show_extra_button"
                  type="checkbox"
                  label={Lang['SHOW_EXTRA_BUTTON'][data.languageReducer.userSettings.admin_panel_language] + ' ?'}
                  checked={formData.show_extra_button}
                  onChange={e => {
                    setFormData({
                      ...formData,
                      show_extra_button: e.target.checked
                    })
                  }} />
              </FormGroup>
            </Col>
            {
              formData.show_extra_button && (
                <>

                  <Col lg={12}>
                    <FormGroup>
                      <MultilingualInput
                        label={Lang['BUTTON_TEXT'][data.languageReducer.userSettings.admin_panel_language]}
                        selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
                        value={formData.extra_button_json.content}
                        valueName='content'
                        parent={formData.extra_button_json}
                        onChangeValue={(parentName, formDataValue) => {
                          setFormData({
                            ...formData,
                            extra_button_json: formDataValue
                          })
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={12}>
                    <LinkInput
                      selectedContainer={formData.extra_button_json}
                      onUpdate={(updatedDom) => {
                        setFormData({
                          ...formData,
                          extra_button_json: {
                            ...updatedDom
                          }
                        })
                        //onChangeRedirectInfo(updatedDom)
                      }}
                      setMediaDatabase={(isOpen) => {
                        toggleMediaDatabase(isOpen)
                      }}
                      anchorLinks={anchorLinks}
                      pages={pages}
                      selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
                    />
                  </Col>
                </>
              )
            }
            {
              formData.show_buy_ticket && (
                <Col lg={12}>
                  <FormGroup>
                    <Label>
                      {Lang['EVENT_ID'][data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <Input
                      value={formData.event_id || ''}
                      onChange={e => {
                        setFormData({
                          ...formData,
                          event_id: e.target.value
                        })
                      }}
                    >
                    </Input>
                  </FormGroup>
                </Col>
              )
            }
          </Row >
        </Form >
        <Card className={'mt-4'}>
          <CardHeader>
            {Lang['SPEAKER'][data.languageReducer.userSettings.admin_panel_language]}
          </CardHeader>
          <CardBody>
            <FormGroup>
              <Label>{Lang['PORTRAIT'][data.languageReducer.userSettings.admin_panel_language]}</Label>
              <ImageField
                onChange={val => setFormData({
                  ...formData,
                  portrait: val
                })}
                fileValue={formData?.portrait?.url}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                {Lang['FIRST_NAME'][data.languageReducer.userSettings.admin_panel_language]}
              </Label>
              <Input
                value={formData.first_name}
                onChange={e => setFormData({
                  ...formData,
                  first_name: e.target.value
                })}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                {Lang['LAST_NAME'][data.languageReducer.userSettings.admin_panel_language]}
              </Label>
              <Input
                value={formData.last_name}
                onChange={e => setFormData({
                  ...formData,
                  last_name: e.target.value
                })}
              />
            </FormGroup>
            <Row>
              <Col lg={12}>
                <FormGroup>
                  <MultilingualInput
                    label={Lang['TITLE_OF_LECTURE'][data.languageReducer.userSettings.admin_panel_language]}
                    selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
                    value={formData.short_description}
                    valueName='short_description'
                    parent={formData}
                    onChangeValue={(parentName, formDataValue) => setFormData(formDataValue)}
                  />
                </FormGroup>
              </Col>
              <Col lg={12}>
                <MultilingualRTE
                  height={'200px'}
                  label={Lang['DESC_OF_LECTURE'][data.languageReducer.userSettings.admin_panel_language]}
                  value={formData.description}
                  onChange={val => setFormData({
                    ...formData,
                    description: val
                  })}
                  selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </ModalBody >
      <ModalFooter>
        <Button
          color='primary'
          onClick={() => {
            let temp = _.cloneDeep(formData)
            if (formData.portrait) {
              temp.portrait = selectedProgramme && formData.portrait.url === selectedProgramme?.portrait.url ? null : {
                raw: formData.portrait.raw,
                filename: formData.portrait.filename
              }
            }

            onSubmit({
              ...temp,
              fair_id: formData.fair_id !== null ? +formData.fair_id : null,
              stage_id: formData.stage_id !== null ? +formData.stage_id : null,
              user_id: formData.user_id !== null ? +formData.user_id : null,
              languages: _.map(formData.languages, langChild => langChild.value)
            })
          }}>
          {Lang['SUBMIT'][data.languageReducer.userSettings.admin_panel_language]}
        </Button>
      </ModalFooter>
    </>
  )
}

export default IndustryForm